import { getSoundEffectUrl, type SoundEffect } from './config/soundEffects';
import type { MotionAudioCue } from './animation/animationUtils';
import { playSpeechAudio } from '@/speech/speechAudioContext';

const motionBgm: Record<number, { url: string; startMs: number } | undefined> = {
  259: { url: '/bgm/21.mp3', startMs: 780 },
  264: { url: '/bgm/51.mp3', startMs: 400 },
  267: { url: '/bgm/53.mp3', startMs: 1120 },
};

export const getSimulationBgm = (motionNo: number) => motionBgm[motionNo];

export const playSimulationSoundEffect = (
  sound: SoundEffect,
  signal?: AbortSignal,
): Promise<void> => playSimulationAudio(getSoundEffectUrl(sound), signal);

export const playSimulationBgm = (motionNo: number, signal?: AbortSignal): Promise<void> => {
  const bgm = getSimulationBgm(motionNo);
  return bgm ? playSimulationAudio(bgm.url, signal) : Promise.resolve();
};

const playSimulationAudio = async (
  url: string,
  signal?: AbortSignal,
): Promise<void> => {
  if (signal?.aborted) return;
  try {
    const response = await fetch(url, { signal });
    if (!response.ok) throw new Error(`音声ファイルを取得できませんでした: ${url} (HTTP ${response.status})`);
    const audio = await response.arrayBuffer();
    if (signal?.aborted) return;
    await playSpeechAudio(audio, signal);
  } catch (error) {
    if (signal?.aborted && error instanceof DOMException && error.name === 'AbortError') return;
    throw error;
  }
};

export const playSimulationMotionAudio = (cue: MotionAudioCue, signal?: AbortSignal): Promise<void> => {
  if (!['voice', 'sound'].includes(cue.kind) || !Number.isInteger(cue.id) || cue.id <= 0) {
    return Promise.reject(new Error('Invalid motion audio cue'));
  }
  const folder = cue.kind === 'voice' ? 'voice' : 'sounds';
  return playSimulationAudio(`/${folder}/${cue.id}.mp3`, signal);
};